var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.36548 52.2805C9.75614 52.0461 10.1468 51.7726 10.4984 51.4405L49.9945 14.7768L89.4905 51.4405C89.8421 51.7726 90.2132 52.0461 90.6234 52.2805V87.4988C90.6234 94.394 85.0174 100 78.1222 100H21.8667C14.9715 100 9.36548 94.394 9.36548 87.4988V52.2805Z",
    fill: "#C9C9C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7362 1.67009C48.1388 -0.556695 51.8501 -0.556695 54.2332 1.67009L97.9874 42.2991C100.527 44.643 100.663 48.6083 98.3195 51.1281C95.9755 53.6478 92.0103 53.8041 89.4905 51.4601L49.9945 14.7768L10.4984 51.4406C7.9591 53.7846 4.0134 53.6478 1.66942 51.1085C-0.67456 48.5692 -0.537827 44.6235 2.00148 42.2795L45.7558 1.65055L45.7362 1.67009Z",
    fill: "#C9C9C9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.ea1234180f4535b0fc668867b4c0642c.svg";
export { ForwardRef as ReactComponent };